export function clearNum(string) {
	return +string.replace(/\s/g, '')
}
